import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { KatButton, KatColumn, KatRow } from '@amzn/katal-react';
import { CountryCode, getPageViewForSignInPageUrl, PageViewPNF } from '../urls-config';
import { BrandRegistryInfoAlertBox } from './BrandRegistryInfoAlertBox';
import { AuthenticationState } from './hooks/useTrimContext';

interface PnfSignInPageProps {
  authenticationState?: AuthenticationState ;
  domainCountryCode: CountryCode;
}

const PnfSignInPage: React.FC<PnfSignInPageProps> = (props: PnfSignInPageProps) => {
  const { t } = useTranslation(['pnf_website_components', 'pnf_retract']);
  const { authenticationState, domainCountryCode } = props;

  const location = useLocation();

  const pageView = getPageViewForSignInPageUrl(location.pathname);

  const handleSignInClick = () => {
    window.location.href = authenticationState?.signInUrl || '';
  };
  return (
    <div className="page-padding">
      {/* Page container for page level padding */}
      <KatRow className="d-flex justify-content-between">
        <KatColumn lg={6} md={6} xs={6}>
          <KatRow className="pt-4">
            <h1>
              {PageViewPNF.RETRACT === pageView
                ? t('pnf-retract-form-title')
                : t('public-notice-form-header')}
            </h1>
          </KatRow>
          <KatRow className="pt-2">
            <h2>{t('public-notice-form-required-sign-in-auth-title')}</h2>
            <p>
              {PageViewPNF.RETRACT === pageView
                ? t('pnf-retract-signin-instructions')
                : t('public-notice-form-submit-infringement-report')}
            </p>
          </KatRow>
          <KatRow className="align-items-center">
            <KatButton
              id="pnf-website-sign-in-button"
              variant="primary"
              onClick={handleSignInClick}
            >
              {t('public-notice-form-sign-in-button')}
            </KatButton>
            <span className="ms-1" id="create-account">
              {t('public-notice-form-required-sign-in-new-to-amazon')}
              <a className="ms-1" href={authenticationState?.registerUrl}>
                {t('public-notice-form-required-sign-in-create-an-account')}
              </a>
            </span>
          </KatRow>
          {
            PageViewPNF.REPORT === pageView &&
            <>
              <KatRow className="pt-4">
                <h2>{t('public-notice-form-instructions-title')}</h2>
                {/* TODO: Deprecate country specific strings; generate links with string interpolation */}
                <span dangerouslySetInnerHTML={{ __html:
                            t([`public-notice-form-instructions-${domainCountryCode.toLowerCase()}`,
                              'public-notice-form-instructions']) }}
                />
              </KatRow>
              <KatRow className="pt-2">
                <h2>{t('public-notice-form-we-do-not-enforce-title')}</h2>
                {/*
               TODO: Deprecate country specific strings; split string content to render
                based on what is supported in the domain marketplace
               */}
                <span dangerouslySetInnerHTML={{ __html:
                            t([`public-notice-form-we-do-not-enforce-instructions-${domainCountryCode.toLowerCase()}`,
                              'public-notice-form-we-do-not-enforce-instructions']) }}
                />
              </KatRow>
            </>
          }
          {
            PageViewPNF.RETRACT === pageView &&
              <KatRow className="pt-4">
                <h2>{t('pnf-retract-about')}</h2>
                <p>{t('pnf-retract-info')}</p>
              </KatRow>
          }
        </KatColumn>
        <KatColumn lg={4} md={4} xs={4}>
          <BrandRegistryInfoAlertBox domainCountryCode={domainCountryCode} />
        </KatColumn>
      </KatRow>
    </div>
  );
};
export default PnfSignInPage;
